/* eslint-disable @typescript-eslint/no-explicit-any */
import Imm from './ImmutableHelpers';
import DataStore from './DataStore';
import toStringArray from './shared/toStringArray';
import { APP_FIELDS } from './shared/constants/Constants';
import { trimFieldsForVendor } from './shared/trimFields';

import {
  Vendor,
  Field,
  VendorSummaryWithMarkets as VendorSummary,
} from '../types/shared/Vendor';

const {
  ID_FIELD_NAME,
  ID_FIELD_CONTACT,
  ID_FIELD_EMAIL,
  ID_FIELD_CATEGORY,
} = APP_FIELDS;

let dataStore = DataStore.getInstance('app');

class VendorActions {
  // Note: Not being used.
  static _normalize(vendor: Vendor) {
    let { id, fields } = vendor;
    let result = {
      id,
      name: value(fields.getByID(ID_FIELD_NAME)),
      contact: value(fields.getByID(ID_FIELD_CONTACT)),
      email: value(fields.getByID(ID_FIELD_EMAIL)),
      category: value(fields.getByID(ID_FIELD_CATEGORY)),
      status: vendor.status,
    };
    return result;
  }

  static updateVendor(id: string, updates: Partial<Vendor>) {
    let updatesWithTrimmedFields = trimFieldsForVendor(updates);
    let fullVendor = dataStore.getX('vendors/:id', [id]);
    if (fullVendor) {
      let newVendor = Imm.setProperties(fullVendor, updatesWithTrimmedFields);
      dataStore.setX('vendors/:id', [id], newVendor);
      updateVendorIndex(id, generateSummary(newVendor));
    } else {
      // Only allow update of certain fields if we don't have access to the full vendor.
      updateVendorIndex(id, normalizeSummary(updatesWithTrimmedFields));
    }
  }

  static updateActiveVendor(id: string, updates: Partial<Vendor>) {
    updateVendorIndex(id, normalizeSummary(updates), true);
  }

  static deleteVendor(id: string) {
    let vendors = dataStore.get('vendors');
    if (!vendors) {
      return;
    }
    let newVendors = vendors.filter((vendor) => vendor.id !== id);
    dataStore.set('vendors', newVendors);
    let fullVendor = dataStore.getX('vendors/:id', [id]);
    if (fullVendor) {
      dataStore.setX('vendors/:id', [id], undefined);
    }
  }
}

function updateVendorIndex(
  id: string,
  updates: Partial<VendorSummary>,
  activeVendors = false,
) {
  let vendors = activeVendors
    ? dataStore.get('vendors/active')
    : dataStore.get('vendors');
  if (!vendors) {
    return;
  }
  let index = vendors.getIndexByID(id);
  let oldVendor = vendors.getByIndex(index);
  if (!oldVendor) {
    return;
  }
  let newVendor = Imm.setProperties(oldVendor, updates);
  let newVendors = vendors.setByIndex(index, newVendor);
  dataStore.set(activeVendors ? 'vendors/active' : 'vendors', newVendors);
}

function generateSummary(vendor: Vendor): Partial<VendorSummary> {
  let { id, fields, tags, status } = vendor;
  let category = value(fields.getByID(ID_FIELD_CATEGORY));
  return {
    id,
    name: toString(value(fields.getByID(ID_FIELD_NAME))),
    contact: toString(value(fields.getByID(ID_FIELD_CONTACT))),
    email: toString(value(fields.getByID(ID_FIELD_EMAIL))),
    category: category ? toStringArray(category) : undefined,
    tags: toStringArray(tags),
    status,
  };
}

function normalizeSummary(updates: { [key: string]: any }) {
  let { tags, status, notes } = updates;
  let result: Partial<VendorSummary> = {};
  if (tags != null) {
    result.tags = toStringArray(tags);
  }
  if (typeof status === 'string') {
    result.status = status;
  }
  if (typeof notes === 'string') {
    result.notes = notes;
  }
  return result;
}

function value(field: Field | null | undefined): unknown {
  return field ? field.value : null;
}

function toString(input: unknown): string | null | undefined {
  return typeof input === 'string' ? input : null;
}

export default VendorActions;
